import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const AuthLayout = ({ children, title, subtitle }) => {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col md:flex-row">
      {/* Left Side: Branding/Marketing */}
      <div className="hidden md:flex md:w-1/2 bg-blue-600 p-12 text-white flex-col justify-between relative overflow-hidden">
        <div className="relative z-10">
          <Link to="/" className="flex items-center space-x-2 mb-12">
            <div className="w-10 h-10 bg-white rounded-xl flex items-center justify-center">
              <span className="text-blue-600 font-bold text-xl">BA</span>
            </div>
            <span className="text-2xl font-bold">Business 360°</span>
          </Link>
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-5xl font-bold mb-6 leading-tight">
              Unlock Your Business Potential.
            </h1>
            <p className="text-xl text-blue-100 max-w-md">
              Join thousands of leaders using AI-driven assessments to track growth and optimize performance.
            </p>
          </motion.div>
        </div>
        
        <div className="relative z-10">
          <div className="flex -space-x-4 mb-4">
            {[1,2,3,4].map(i => (
              <div key={i} className="w-12 h-12 rounded-full border-4 border-blue-600 bg-blue-400 flex items-center justify-center text-xs font-bold">
                U{i}
              </div>
            ))}
          </div>
          <p className="text-blue-100 text-sm">Trusted by 2,000+ businesses worldwide</p>
        </div>

        {/* Abstract Background Shapes */}
        <div className="absolute top-[-10%] right-[-10%] w-96 h-96 bg-blue-500 rounded-full blur-3xl opacity-20"></div>
        <div className="absolute bottom-[-10%] left-[-10%] w-96 h-96 bg-indigo-500 rounded-full blur-3xl opacity-20"></div>
      </div>

      {/* Right Side: Auth Forms */}
      <div className="flex-1 flex items-center justify-center p-6 md:p-12">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="w-full max-w-md"
        >
          <div className="mb-8 md:hidden">
             <Link to="/" className="flex items-center space-x-2">
              <div className="w-8 h-8 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">BA</span>
              </div>
              <span className="text-xl font-bold text-gray-900">Business 360°</span>
            </Link>
          </div>
          <h2 className="text-3xl font-bold text-gray-900 mb-2">{title}</h2>
          <p className="text-gray-500 mb-8">{subtitle}</p>
          {children}
        </motion.div>
      </div>
    </div>
  );
};

export default AuthLayout;